/**
 * @file Utility that needs description.
 * @copyright Copyright (c) 2018-present, Graham Fairweather
 * @module isUndefined
 */

export default function isUndefined(value) {
  return typeof value === 'undefined';
}
